
<div class="card">
  <div class="card-header">
    <h5 class="card-title">School People List</h5>
  </div>
  <div class="card-body">
    <app-school-people-list [schoolId]="schoolId" (itemClick)="itemClicked($event)"></app-school-people-list>
  </div>
</div>